var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-grid-vue',_vm._b({ref:"agEmployees",staticClass:"ag-theme-alpine",staticStyle:{"height":"65vh"},on:{"cellEditRequest":_vm.onCellEditRequest}},'ag-grid-vue',_vm.agEmployees,false))}
var staticRenderFns = []

export { render, staticRenderFns }